// pages
import Home from "./pages/Home";
import Electricity from "./pages/Electricity";
// import About from "./pages/About";
// import Products from "./pages/Products";

// other
import {FC} from "react";

// interface
interface Route {
    key: string,
    title: string,
    path: string,
    enabled: boolean,
    component: FC<any>,
    param?: string,
}

export const routes: Array<Route> = [
    {
        key: 'home-route',
        title: 'Hjem',
        path: '/',
        enabled: true,
        component: Home
    },
    {
        key: 'electricity-route',
        title: 'Strømkalkulator',
        path: '/electricity',
        enabled: true,
        component: Electricity,
        param: 'monthId',
    },
    // {
    //     key: 'about-route',
    //     title: 'About',
    //     path: '/about',
    //     enabled: true,
    //     component: About
    // },
    // {
    //     key: 'products-route',
    //     title: 'Products',
    //     path: '/products',
    //     enabled: true,
    //     component: Products
    // }
]